function getUrlSocket() {
    // return 'http://192.168.88.69:6001/'; // Solo para red 192.168.88.x

    return 'https://api.grupodracena.com/socket.io'; // Solo para red 192.168.88.x
}

  export default getUrlSocket;